import API_CONFIG from "../config/apiConfig";

// Get auth token from localStorage
const getAuthToken = () => {
  return localStorage.getItem("authToken");
};

// Generic API call function
const apiClient = async (
  endpoint,
  method = "GET",
  data = null,
  requiresAuth = true
) => {
  const url = `${API_CONFIG.BASE_URL}${endpoint}`;

  const headers = {
    ...API_CONFIG.HEADERS,
  };

  // Add authorization header if required
  if (requiresAuth) {
    const token = getAuthToken();
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }
  }

  const config = {
    method,
    headers,
  };

  // Add body for POST, PUT, PATCH requests
  if (data && ["POST", "PUT", "PATCH"].includes(method)) {
    config.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(url, config);

    // ✅ If token expired or unauthorized
    if (response.status === 401) {
      localStorage.setItem(
        "logoutMessage",
        "Your session has expired. Please log in again."
      );
      localStorage.removeItem("authToken");
      window.location.href = "/login";
      return;
    }

    // Handle response
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP Error: ${response.status}`);
    }

    // Return parsed JSON
    const responseData = await response.json();
    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    console.error("API Error:", error);
    return {
      success: false,
      error: error.message || "An error occurred",
    };
  }
};

export default apiClient;
